export default __webpack_public_path__ + "static/media/dp_upload.115da24d.svg";